<template>
  <div
    v-if="userData"
    class="navbar-container d-flex content align-items-center"
  >

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none mr-1">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-lg-flex">
      <bookmarks />
    </div>

    <!-- Right Col -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <user-online-status></user-online-status>
<!--      <locale />-->
      <employee-work-day></employee-work-day>
      <theme-settings></theme-settings>
<!--      <search-bar />-->
<!--      <cart-dropdown />-->
      <chat-button
        v-if="$ability.can('create', entityChat) && $ability.can('create', entityChatMessage)"
      ></chat-button>
      <notification-dropdown></notification-dropdown>
      <user-dropdown></user-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import Bookmarks from '@/core/layouts/components/app-navbar/components/Bookmarks.vue'
import NotificationDropdown from '@/core/layouts/components/app-navbar/components/NotificationDropdown.vue'
import UserDropdown from '@/core/layouts/components/app-navbar/components/UserDropdown.vue'
import ChatButton from '@/core/layouts/components/app-navbar/components/chat-button/ChatButton.vue'
import { entityChat, entityChatMessage } from '@/libs/acl/entities'
import ThemeSettings from '@/core/layouts/components/app-navbar/components/ThemeSettings'
import EmployeeWorkDay from '@/core/layouts/components/app-navbar/components/EmployeeWorkDay.vue'
import UserOnlineStatus from '@/core/layouts/components/app-navbar/components/UserOnlineStatus.vue'
import { computed } from 'vue'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    UserOnlineStatus, ThemeSettings, BLink, BNavbarNav, Bookmarks, NotificationDropdown, UserDropdown, ChatButton,
    EmployeeWorkDay
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      entityChat: entityChat,
      entityChatMessage: entityChatMessage,
    }
  },
  setup() {
    const userData = computed(() => getUserData())

    return {
      userData
    }
  }
}
</script>
